export interface DemoBuyerPartner {
  id: string;
  name: string;
  company: string;
  type: 'internal' | 'external';
  role: string;
  email: string;
  phone: string;
  dealIds: string[];
  addedAt: { toDate: () => Date };
  isVerified: boolean;
}

export const DEMO_BUYER_PARTNERS: DemoBuyerPartner[] = [
  {
    id: 'demo-partner-1',
    name: 'Marie Dupont',
    company: 'Dupont Consulting',
    type: 'internal',
    role: 'CPA / Accounting',
    email: 'marie.dupont@dupontconsulting.ca',
    phone: '+1 514-555-0101',
    dealIds: [],
    addedAt: { toDate: () => new Date() },
    isVerified: true,
  },
  {
    id: 'demo-partner-2',
    name: 'Jean-Pierre Martin',
    company: 'Martin Legal',
    type: 'internal',
    role: 'Business Lawyer',
    email: 'jp.martin@martinlegal.ca',
    phone: '+1 514-555-0202',
    dealIds: [],
    addedAt: { toDate: () => new Date() },
    isVerified: true,
  },
  {
    id: 'demo-partner-3',
    name: 'Sophie Tremblay',
    company: 'Tremblay Tax Advisors',
    type: 'external',
    role: 'Tax Advisor',
    email: 'sophie@tremblaytax.com',
    phone: '+1 438-555-0303',
    dealIds: [],
    addedAt: { toDate: () => new Date() },
    isVerified: true,
  },
  {
    id: 'demo-partner-4',
    name: 'Carlos Rodriguez',
    company: 'Global Immigration Services',
    type: 'external',
    role: 'Immigration Lawyer',
    email: 'carlos@globalimmigration.ca',
    phone: '+1 514-555-0404',
    dealIds: [],
    addedAt: { toDate: () => new Date() },
    isVerified: false,
  },
];

export const mergeDemoBuyerPartners = <T extends { id: string; name: string }>(partners: T[]) => {
  const realPartnerNames = new Set(partners.map((partner) => partner.name));
  return [
    ...partners,
    ...DEMO_BUYER_PARTNERS.filter((partner) => !realPartnerNames.has(partner.name)) as unknown as T[],
  ];
};